export default __webpack_public_path__ + "static/media/AudioImg.673cca8c.jpg";